import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActiveFooter, getFooterTranslationColumns } from "../_actions/cms.actions";
import FooterColumnTypeENUM from "../assests/enums/footerColumnType";
import { useTranslation } from 'react-i18next';
import { useCallback } from "react";

function Footer() {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const footer = useSelector((state) => state.website.footer.activeFooter);
    const selectedLang = useCallback(() => i18n.language.split("-")[0].toUpperCase(), [i18n.language]);
    const [translatedColumns, setTranslatedColumns] = useState([]);

    useEffect(() => {
        dispatch(getActiveFooter());
        if (selectedLang() !== "EN")
            getFooterTranslationColumns(selectedLang())
                .then((res) => setTranslatedColumns(res));
    }, [selectedLang, dispatch]);

    if (!footer?.cmsFooterColumns) return <></>;

    let layout = footer.layout.split("-");
    let htmlPositionIndex = layout.indexOf("TEXT");
    let skipHtmlPositionIndex = htmlPositionIndex + 1;
    let mainLogosColumns = layout.filter((i, inx) => i === "LOGO" && inx < htmlPositionIndex);
    let partnersColumn = layout.filter((i, inx) => i === "LOGO" && inx > htmlPositionIndex);

    function renderLogo(position) {
        let logo = footer.cmsFooterColumns.find((x) => x.position === position && x.type === FooterColumnTypeENUM.Logo);

        let { link, footerLogoPreview } = logo || {};

        return !footerLogoPreview ? <></> : (
            <a href={link || ""} target="_blank" rel="noreferrer">
                <img src={footerLogoPreview} alt={link} />
            </a>
        );
    }

    function renderHtml() {
        if (selectedLang() === "EN" || (selectedLang() !== "EN" && !(translatedColumns && translatedColumns.length > 0))) {
            return footer.cmsFooterColumns.find((x) => x.position === htmlPositionIndex + 1 && x.type === FooterColumnTypeENUM.Text)?.text ?? "";
        }
        else if (translatedColumns && translatedColumns.length > 0) {
            return translatedColumns.find((x) => x.position === htmlPositionIndex + 1)?.text ?? "";
        }
        return "";
    }

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__row">
                    {mainLogosColumns.map((column, inx) => <div key={inx} className="footer__logo">
                        {renderLogo(inx + 1)}
                    </div>)}
                    <div
                        className="ack"
                        dangerouslySetInnerHTML={{ __html: renderHtml() }}
                    />
                    <ul className="footer__partners">
                        {partnersColumn.map((column, inx) => <li key={inx}>{renderLogo(inx + skipHtmlPositionIndex + 1)}</li>)}
                    </ul>
                </div>
            </div>
        </footer>
    );
}
export default Footer;
